import insuranceAccidentalDeath from '../../assets/icons/v3/insurance/insurance_accidental_death.svg?url';
import insuranceAccidentalDissability from '../../assets/icons/v3/insurance/insurance_accidental_dissability.svg?url';
import insuranceBike from '../../assets/icons/v3/insurance/insurance_bike.svg?url';
import insuranceCancer from '../../assets/icons/v3/insurance/insurance_cancer.svg?url';
import insuranceCarInsurance from '../../assets/icons/v3/insurance/insurance_car_insurance.svg?url';
import insuranceCerebralStroke from '../../assets/icons/v3/insurance/insurance_cerebral_stroke.svg?url';
import insuranceComplementary from '../../assets/icons/v3/insurance/insurance_complementary.svg?url';
import insuranceCoverage from '../../assets/icons/v3/insurance/insurance_coverage.svg?url';
import insuranceDental from '../../assets/icons/v3/insurance/insurance_dental.svg?url';
import insuranceFamily from '../../assets/icons/v3/insurance/insurance_family.svg?url';
import insuranceHearphones from '../../assets/icons/v3/insurance/insurance_hearphones.svg?url';
import insuranceHospitalization from '../../assets/icons/v3/insurance/insurance_hospitalization.svg?url';
import insuranceInfarction from '../../assets/icons/v3/insurance/insurance_infarction.svg?url';
import insuranceInsuranceGroup from '../../assets/icons/v3/insurance/insurance_insurance_group.svg?url';
import insuranceMedicalExpenses from '../../assets/icons/v3/insurance/insurance_medical_expenses.svg?url';
import insuranceMedicine from '../../assets/icons/v3/insurance/insurance_medicine.svg?url';
import insuranceMyocardialInfarction from '../../assets/icons/v3/insurance/insurance_myocardial_infarction.svg?url';
import insuranceNoCoverage from '../../assets/icons/v3/insurance/insurance_no_coverage.svg?url';
import insuranceSaveMoney from '../../assets/icons/v3/insurance/insurance_save_money.svg?url';
import insuranceStolenBycicle from '../../assets/icons/v3/insurance/insurance_stolen_bycicle.svg?url';
import insuranceVetOnline from '../../assets/icons/v3/insurance/insurance_vet_online.svg?url';

export const BDS_PICTOGRAM_PATHS: Record<string, string> = {
  insuranceAccidentalDeath,
  insuranceAccidentalDissability,
  insuranceBike,
  insuranceCancer,
  insuranceCarInsurance,
  insuranceCerebralStroke,
  insuranceComplementary,
  insuranceCoverage,
  insuranceDental,
  insuranceFamily,
  insuranceHearphones,
  insuranceHospitalization,
  insuranceInfarction,
  insuranceInsuranceGroup,
  insuranceMedicalExpenses,
  insuranceMedicine,
  insuranceMyocardialInfarction,
  insuranceNoCoverage,
  insuranceSaveMoney,
  insuranceStolenBycicle,
  insuranceVetOnline
};
